/**
 * @generated SignedSource<<af0514383a1313a08f1b1e23131fb7f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoBlockData$data = {
  readonly event: {
    readonly __typename: "AuthorizedEvent";
    readonly canWrite: boolean;
    readonly created: string;
    readonly creators: ReadonlyArray<string>;
    readonly description: string | null | undefined;
    readonly hasPassword: boolean;
    readonly id: string;
    readonly isLive: boolean;
    readonly metadata: Record<string, Record<string, string[]>>;
    readonly opencastId: string;
    readonly series: {
      readonly id: string;
      readonly opencastId: string;
      readonly title: string;
    } | null | undefined;
    readonly syncedData: {
      readonly duration: number;
      readonly endTime: string | null | undefined;
      readonly startTime: string | null | undefined;
      readonly thumbnail: string | null | undefined;
      readonly updated: string;
    } | null | undefined;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"VideoPageAuthorizedData">;
  } | {
    readonly __typename: "NotAllowed";
    readonly __typename: "NotAllowed";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly showLink: boolean;
  readonly showTitle: boolean;
  readonly " $fragmentType": "VideoBlockData";
};
export type VideoBlockData$key = {
  readonly " $data"?: VideoBlockData$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoBlockData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opencastId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoBlockData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLive",
              "storageKey": null
            },
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "created",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "creators",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "metadata",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canWrite",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPassword",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Series",
              "kind": "LinkedField",
              "name": "series",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SyncedEventData",
              "kind": "LinkedField",
              "name": "syncedData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "duration",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startTime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endTime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumbnail",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VideoPageAuthorizedData"
            }
          ],
          "type": "AuthorizedEvent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showLink",
      "storageKey": null
    }
  ],
  "type": "VideoBlock",
  "abstractKey": null
};
})();

(node as any).hash = "6edee331b01b9fe04940a94c7d36a35d";

export default node;
